import { ColetaFluxo, ColetaFluxoFila, ColetaFluxoResultado } from '../../types/coleta';

export function devePerguntarColeta(fluxo: ColetaFluxo): boolean {
  return !fluxo.utilizavel;
}

export const AVISO_LEMIT_QUANDO_ASSINADO =
  'A busca no Lemmit ainda será feita quando o contrato estiver Assinado.';

export const AVISO_LEMIT_PENDENTE =
  'A busca no Lemmit ainda está pendente.';

/** Criado, Aguardando assinatura, Enviado, Não Assinado, Rascunho, Pedido antigo. */
const STATUS_ANTES_DE_ASSINADO = new Set([0, 34, 37, 38, 65, 69]);
const STATUS_ASSINADO = 1;

const NOMES_ANTES_DE_ASSINADO = new Set([
  '0',
  'criado',
  '34',
  'aguardandoassinatura',
  '37',
  'enviado',
  '38',
  'naoassinado',
  'nãoassinado',
  '65',
  'rascunho',
  '69',
  'pedidoantigo',
]);

export function contratoAssinadoOuDepois(status?: number | string | null): boolean {
  if (status == null || status === '') return false;
  if (typeof status === 'number') {
    if (status === STATUS_ASSINADO) return true;
    return !STATUS_ANTES_DE_ASSINADO.has(status);
  }
  const normalizado = status.trim().toLowerCase().replace(/\s+/g, '');
  if (!normalizado) return false;
  if (normalizado === '1' || normalizado === 'assinado') return true;
  if (NOMES_ANTES_DE_ASSINADO.has(normalizado)) return false;
  const numero = Number(normalizado);
  if (Number.isFinite(numero)) {
    if (numero === STATUS_ASSINADO) return true;
    return !STATUS_ANTES_DE_ASSINADO.has(numero);
  }
  return true;
}

export function avisoLemitQualidade(entrada: {
  temResultadoP2b: boolean;
  temTelefoneLemit: boolean;
  lemitAindaEsperado: boolean;
  assinadoOuDepois: boolean;
  adminEncontradoNoP2b?: boolean;
}): string {
  if (
    entrada.adminEncontradoNoP2b
    || !entrada.temResultadoP2b
    || entrada.temTelefoneLemit
    || !entrada.lemitAindaEsperado
  ) {
    return '';
  }
  return entrada.assinadoOuDepois ? AVISO_LEMIT_PENDENTE : AVISO_LEMIT_QUANDO_ASSINADO;
}

export function textoDaFila(fila?: ColetaFluxoFila | null): string {
  if (!fila) return '';
  if (fila.falha || fila.estado === 'erro') return fila.falha || 'A coleta falhou.';
  if (fila.aguardaLogin) return 'Aguardando um login.';
  if (fila.estado === 'em_andamento') return 'Sendo processado.';
  if (fila.estado === 'na_fila') {
    const posicao = fila.posicao ? `Posição ${fila.posicao} na fila.` : 'Na fila.';
    const tempo = fila.estimativaMinutos ? ` Estimativa: ${fila.estimativaMinutos} min.` : '';
    return `${posicao}${tempo}`;
  }
  return '';
}

const FUSO_SAO_PAULO = 'America/Sao_Paulo';

function doisDigitos(valor: string): string {
  const numero = valor.replace(/\D/g, '');
  if (!numero) return '';
  return numero.padStart(2, '0').slice(-2);
}

function instanteDeBuscadoEm(valor: number | string | null | undefined): Date | null {
  if (typeof valor === 'number') {
    if (!Number.isFinite(valor) || valor <= 0) return null;
    const data = new Date(valor * 1000);
    return Number.isNaN(data.getTime()) ? null : data;
  }
  if (typeof valor !== 'string') return null;
  const texto = valor.trim();
  if (!texto) return null;
  const data = new Date(texto);
  return Number.isNaN(data.getTime()) ? null : data;
}

function formatarEmSaoPaulo(data: Date): string {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: FUSO_SAO_PAULO,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(data);

  const pegar = (tipo: Intl.DateTimeFormatPartTypes) =>
    partes.find(parte => parte.type === tipo)?.value ?? '';

  const dia = doisDigitos(pegar('day'));
  const mes = doisDigitos(pegar('month'));
  const ano = pegar('year').replace(/\D/g, '');
  let hora = doisDigitos(pegar('hour'));
  if (hora === '24') hora = '00';
  const minuto = doisDigitos(pegar('minute'));
  const segundo = doisDigitos(pegar('second'));
  if (!dia || !mes || ano.length !== 4 || !hora || !minuto || !segundo) return '-';
  return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
}

export function textoDaData(resultado?: Pick<ColetaFluxoResultado, 'buscadoEm'> | null): string {
  const instante = instanteDeBuscadoEm(resultado?.buscadoEm);
  if (!instante) return '-';
  return formatarEmSaoPaulo(instante);
}
